export const photoCaptureUpdateAttachedArtifactIdReducer = (state, action) => {
    return Object.assign(Object.assign({}, state), { attachedArtifactIds: action.payload });
};
//# sourceMappingURL=photoCaptureUpdateAttachedArtifactIdReducer.js.map